import { memo, useMemo } from 'react';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';

import { PRICE_BUCKET_LABELS } from '../../OfferFilters.consts';
import { OfferPriceBucket } from '../../OfferFilters.types';

interface IPriceFilterProps {
  selected: OfferPriceBucket[];
  onSelectionChange: (buckets: OfferPriceBucket[]) => void;
}

const PRICE_OPTIONS: FilterOption[] = Object.values(OfferPriceBucket).map(
  (b: OfferPriceBucket): FilterOption => ({
    label: PRICE_BUCKET_LABELS[b],
    value: b
  })
);

export const PriceFilter = memo(({ selected, onSelectionChange }: IPriceFilterProps) => {
  const selectedValues = useMemo(() => selected.map(String), [selected]);

  return (
    <FilterPopover
      label="Price"
      filterType={FilterType.CHECKLIST}
      options={PRICE_OPTIONS}
      selectedItems={selectedValues}
      onSelectionChange={onSelectionChange as (items: string[]) => void}
      dataTestId="offers-price-filter"
      popoverHeight="auto"
    />
  );
});

PriceFilter.displayName = 'PriceFilter';
